import { Individual } from "@/Common/Api/Individuals/Dto/Individual";
import { HealthCardValidatorFactory, HealthCardValidatorRequest } from "@/Common/Components/Patient/HealthCardComponents/HealthCardValidator";
import { CommonStatus } from "@/Common/Models/Patient/Enum/CommonStatus";
import { HealthInsuranceEligibility } from "@/Common/Models/Patient/HealthInsuranceEligibility/HealthInsuranceEligibility";
import { HealthInsuranceEligibilityStatus } from "@/Common/Models/Patient/HealthInsuranceEligibility/HealthInsuranceEligibilityStatus";
import { CanadaState } from "@/Common/Resources/Lookups/Enums/CommonLookupCodes";

class BritishColumbiaMspCoverageHelper {
    private readonly noRestriction = "NO RESTRICTION";
    private readonly bcHealthCardValidator = HealthCardValidatorFactory.getValidator(
        cacheStore.FindLookupByLookupCode("CNCANADA").LookupID,
        cacheStore.GetLookupIdForProvince(CanadaState.BritishColumbia)
    );

    public mspEligibilityHasExtraInformation(mspEligibility: HealthInsuranceEligibility, individual: Individual, healthCardNumber: string): boolean {
        return !this.isMspInformationEmpty(mspEligibility)
            || !individual?.DateOfBirth
            || !this.isPersonalHealthNumberValid(individual, healthCardNumber)
            || mspEligibility?.Eligibility === HealthInsuranceEligibilityStatus.Unknown;
    }

    public isMspInformationEmpty(mspEligibility: HealthInsuranceEligibility): boolean {
        return IsNullOrWhiteSpace(mspEligibility?.EligibilityMessage)
            && (
                IsNullOrWhiteSpace(mspEligibility?.PatientRestriction)
                || mspEligibility?.PatientRestriction === this.noRestriction
            );
    }

    public isPersonalHealthNumberValid(individual: Individual, healthCardNumber: string): boolean {
        if (!individual || IsNullOrWhiteSpace(healthCardNumber))
            return false;

        const request = new HealthCardValidatorRequest(
            healthCardNumber,
            individual.FirstName,
            individual.LastName,
            individual.DateOfBirth,
            individual.GenderLookupId
        );

        return this.bcHealthCardValidator.isValid(request);
    }

    public getEligibilityStatus(mspEligibility: HealthInsuranceEligibility): CommonStatus {
        switch (mspEligibility.Eligibility) {
            case HealthInsuranceEligibilityStatus.Covered: return CommonStatus.Covered;
            case HealthInsuranceEligibilityStatus.NotCovered: return CommonStatus.NotCovered;
            default: return CommonStatus.Question;
        }
    }
}

export { BritishColumbiaMspCoverageHelper };
